import {
  QueryKey,
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { ApiError } from 'next/dist/server/api-utils';

import { ApiResponse } from '@/types/api';
import { api } from '@/utils/api';

// 요청 타입
export interface PutChangeTourStatusRequest {
  tourStatus: 'NOT_STARTED' | 'SKIPPED' | 'COMPLETED';
}

// API 함수
export const putChangeTourStatus = ({
  tourStatus,
}: PutChangeTourStatusRequest) => {
  return api.put<ApiResponse>('/user/tour-status', {
    tourStatus,
  });
};

// React Query 훅
const useChangeTourStatus = <TError = AxiosError<ApiError>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse>,
    TError,
    PutChangeTourStatusRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse>,
  TError,
  PutChangeTourStatusRequest,
  QueryKey
> => {
  return useMutation(putChangeTourStatus, { ...options });
};

export default useChangeTourStatus;
